(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gs-find-snacks-hub"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const groupMap = {
      mission: {
        attr: 'findMission',
        param: 'find_mission',
      },
      snack_type: {
        attr: 'findType',
        param: 'find_type',
      },
      flavor_profile: {
        attr: 'findFlavor',
        param: 'find_flavor',
      },
      country: {
        attr: 'findCountry',
        param: 'find_country',
      },
    };

    const paramToGroup = Object.entries(groupMap).reduce((accumulator, [group, config]) => {
      accumulator[config.param] = group;
      return accumulator;
    }, {});

    const formatCount = (count) => `${count} ${count === 1 ? 'Item' : 'Items'} Found`;

    const splitValues = (value) => {
      if (!value) return [];
      return value.split(/\s+/).filter(Boolean);
    };

    const getStateFromInputs = (checkboxes) => {
      const state = {};
      Object.keys(groupMap).forEach((group) => {
        state[group] = [];
      });

      checkboxes.forEach((input) => {
        if (input.checked && state[input.dataset.filterGroup]) {
          state[input.dataset.filterGroup].push(input.value);
        }
      });

      return state;
    };

    const hasFilters = (state) => Object.values(state).some((values) => values.length > 0);

    const initShell = (shell) => {
      if (shell.dataset.gsFindSnacksReady === 'true') return;
      shell.dataset.gsFindSnacksReady = 'true';
      document.documentElement.classList.add('gs-find-snacks-page');
      document.body.classList.add('gs-find-snacks-page');

      const resetHorizontalScroll = () => {
        if (window.scrollX !== 0) {
          window.scrollTo(0, window.scrollY);
        }
      };

      [0, 250, 1000, 2500, 5000].forEach((delay) => {
        window.setTimeout(resetHorizontalScroll, delay);
      });
      window.addEventListener('resize', resetHorizontalScroll, { passive: true });
      window.addEventListener('scroll', resetHorizontalScroll, { passive: true });

      const dialog = shell.querySelector('[data-gs-finder-dialog]');
      const openButtons = shell.querySelectorAll('[data-gs-finder-open]');
      const closeButton = shell.querySelector('[data-gs-finder-close]');
      const resetButton = shell.querySelector('[data-gs-filter-reset]');
      const applyButton = shell.querySelector('[data-gs-filter-apply]');
      const results = shell.querySelector('[data-gs-filter-results]');
      const clearButtons = shell.querySelectorAll('[data-gs-filter-clear]');
      const chipsContainer = shell.querySelector('[data-gs-active-chips]');
      const filterCountTargets = shell.querySelectorAll('[data-gs-filter-count]');
      const resultsViewAll = shell.querySelector('[data-gs-results-view-all]');
      const selectedTarget = shell.querySelector('[data-gs-filter-selected]');
      const resultCards = Array.from(shell.querySelectorAll('[data-gs-result-card]'));
      const resultsGrid = shell.querySelector('[data-gs-results-grid]');
      const emptyState = shell.querySelector('[data-gs-results-empty]');
      const sortControl = shell.querySelector('[data-gs-filter-sort]');
      const checkboxes = Array.from(shell.querySelectorAll('[data-filter-group]'));
      const brandGrid = shell.querySelector('[data-gs-brand-grid]');
      const brandCards = brandGrid ? Array.from(brandGrid.querySelectorAll('[data-gs-brand-card]')) : [];
      let committedState = {};
      let activeTrigger = null;
      let originalCards = [];
      let productWindowExpanded = false;
      const previewProductLimit = 6;
      const filteredProductLimit = 9;
      const resultLayoutClasses = [
        'is-featured-result',
        'is-featured-result--left',
        'is-featured-result--right',
        'is-featured-result--center',
      ];

      Object.keys(groupMap).forEach((group) => {
        committedState[group] = [];
      });

      resultCards.forEach((card, index) => {
        card.dataset.originalIndex = String(index);
      });
      originalCards = [...resultCards];

      brandCards.forEach((card, index) => {
        card.dataset.originalIndex = String(index);
      });

      const arrangeBrandGrid = () => {
        if (!brandGrid || brandCards.length === 0) return;

        const sortedBrands = [...brandCards].sort((a, b) => {
          const countDiff = Number(b.dataset.gsBrandCount || 0) - Number(a.dataset.gsBrandCount || 0);
          if (countDiff !== 0) return countDiff;
          return Number(a.dataset.originalIndex || 0) - Number(b.dataset.originalIndex || 0);
        });

        if (brandGrid.dataset.gsBrandRail === 'true') {
          brandGrid.dataset.gsBrandColumnCount = String(sortedBrands.length);
          brandGrid.dataset.gsBrandVisibleCount = String(sortedBrands.length);
          sortedBrands.forEach((card) => {
            card.hidden = false;
            brandGrid.append(card);
          });
          brandGrid.scrollLeft = 0;
          return;
        }

        const columnCount = (() => {
          const columns = window.getComputedStyle(brandGrid).gridTemplateColumns.trim().split(/\s+/).filter(Boolean).length;
          return Math.max(columns, 1);
        })();
        const maxRows = 2;
        const maxVisibleBrands = columnCount * maxRows;
        let visibleBrandCount = Math.min(sortedBrands.length, maxVisibleBrands);

        if (brandGrid.dataset.gsBrandEvenCount === 'true' && visibleBrandCount > columnCount) {
          const remainder = visibleBrandCount % columnCount;
          if (remainder === 1) {
            visibleBrandCount -= 1;
          }
        }

        brandGrid.dataset.gsBrandColumnCount = String(columnCount);
        brandGrid.dataset.gsBrandVisibleCount = String(visibleBrandCount);

        sortedBrands.forEach((card, index) => {
          card.hidden = index >= visibleBrandCount;
          brandGrid.append(card);
        });
      };

      arrangeBrandGrid();

      let brandResizeFrame = null;
      window.addEventListener('resize', () => {
        if (brandResizeFrame) {
          window.cancelAnimationFrame(brandResizeFrame);
        }
        brandResizeFrame = window.requestAnimationFrame(() => {
          brandResizeFrame = null;
          arrangeBrandGrid();
        });
      });

      const tabButtons = Array.from(shell.querySelectorAll('[data-gs-discovery-tab]'));
      const tabPanels = Array.from(shell.querySelectorAll('[data-gs-tab-panel]'));

      const activateDiscoveryTab = (button) => {
        const group = button.dataset.gsTabGroup;
        const targetId = button.dataset.gsTabTarget;
        if (!group || !targetId) return;

        tabButtons
          .filter((tabButton) => tabButton.dataset.gsTabGroup === group)
          .forEach((tabButton) => {
            const isActive = tabButton === button;
            tabButton.classList.toggle('is-active', isActive);
            tabButton.setAttribute('aria-selected', isActive ? 'true' : 'false');
          });

        tabPanels
          .filter((panel) => panel.dataset.gsTabGroup === group)
          .forEach((panel) => {
            panel.hidden = panel.id !== targetId;
          });
      };

      tabButtons.forEach((button) => {
        button.addEventListener('click', () => {
          activateDiscoveryTab(button);
        });
      });

      const getLabel = (group, value) => {
        const input = checkboxes.find((checkbox) => checkbox.dataset.filterGroup === group && checkbox.value === value);
        return input ? input.dataset.filterLabel : value;
      };

      const getMatches = (state) => {
        return resultCards.filter((card) => {
          return Object.entries(groupMap).every(([group, config]) => {
            const selectedValues = state[group] || [];
            if (selectedValues.length === 0) return true;
            const cardValues = splitValues(card.dataset[config.attr]);
            return selectedValues.some((selectedValue) => cardValues.includes(selectedValue));
          });
        });
      };

      const cloneState = (state) => {
        const clonedState = {};
        Object.keys(groupMap).forEach((group) => {
          clonedState[group] = [...(state[group] || [])];
        });
        return clonedState;
      };

      const refreshOptionAvailability = (state) => {
        const baseState = cloneState(state || getStateFromInputs(checkboxes));

        checkboxes.forEach((input) => {
          const group = input.dataset.filterGroup;
          if (!groupMap[group]) return;

          const testState = cloneState(baseState);
          if (!input.checked) {
            testState[group] = [input.value];
          }

          const hasMatches = getMatches(testState).length > 0;
          const label = input.closest('label');
          input.disabled = !input.checked && !hasMatches;
          if (label) {
            label.hidden = !input.checked && !hasMatches;
          }
        });
      };

      const updateCount = (count) => {
        filterCountTargets.forEach((target) => {
          target.textContent = formatCount(count);
        });
        if (applyButton) {
          applyButton.textContent = `View ${count} ${count === 1 ? 'Item' : 'Items'}`;
        }
      };

      const updateResultsWindowCopy = (totalCount, visibleCount, filteredMode) => {
        if (resultsViewAll) {
          const shouldShowViewAll = filteredMode && totalCount > visibleCount;
          resultsViewAll.hidden = !shouldShowViewAll;
          resultsViewAll.textContent = `View all ${totalCount} ${totalCount === 1 ? 'item' : 'items'}`;
        }
      };

      const syncInputsFromState = () => {
        checkboxes.forEach((input) => {
          input.checked = (committedState[input.dataset.filterGroup] || []).includes(input.value);
        });
      };

      const updateDialogSummary = () => {
        const draftState = getStateFromInputs(checkboxes);
        const matches = getMatches(draftState);
        refreshOptionAvailability(draftState);
        updateCount(matches.length);

        const labels = [];
        Object.entries(draftState).forEach(([group, values]) => {
          values.forEach((value) => labels.push(getLabel(group, value)));
        });

        if (selectedTarget) {
          selectedTarget.textContent = labels.length > 0 ? labels.join(', ') : 'Choose filters to narrow the catalog.';
        }
      };

      const renderChips = () => {
        if (!chipsContainer) return;
        chipsContainer.innerHTML = '';

        Object.entries(committedState).forEach(([group, values]) => {
          values.forEach((value) => {
            const chip = document.createElement('button');
            const label = getLabel(group, value);
            chip.type = 'button';
            chip.textContent = `${label} ×`;
            chip.setAttribute('aria-label', `Remove ${label} filter`);
            chip.addEventListener('click', () => {
              committedState[group] = committedState[group].filter((currentValue) => currentValue !== value);
              productWindowExpanded = false;
              syncInputsFromState();
              renderResults(true, true);
            });
            chipsContainer.append(chip);
          });
        });

        chipsContainer.hidden = chipsContainer.children.length === 0;
      };

      const sortCards = (cards) => {
        const sortValue = sortControl ? sortControl.value : 'recommended';
        const sortedCards = [...cards];

        if (sortValue === 'price-asc') {
          sortedCards.sort((a, b) => Number(a.dataset.price || 0) - Number(b.dataset.price || 0));
        } else if (sortValue === 'price-desc') {
          sortedCards.sort((a, b) => Number(b.dataset.price || 0) - Number(a.dataset.price || 0));
        } else {
          sortedCards.sort((a, b) => Number(a.dataset.originalIndex || 0) - Number(b.dataset.originalIndex || 0));
        }

        return sortedCards;
      };

      const cardHasAnyToken = (card, datasetKey, tokens) => {
        const values = splitValues(card.dataset[datasetKey]).map((value) => value.toLowerCase());
        return tokens.some((token) => values.includes(token));
      };

      const cardHasAnyText = (card, tokens) => {
        const searchText = `${card.dataset.findType || ''} ${card.dataset.title || ''}`.toLowerCase();
        return tokens.some((token) => searchText.includes(token));
      };

      const getPreviewCardRank = (card) => {
        const bestSellerBoost = cardHasAnyToken(card, 'findMission', ['best-sellers', 'best-seller']) ? -1000 : 0;
        return bestSellerBoost + Number(card.dataset.originalIndex || 0);
      };

      const getPreviewShowcaseCards = (cards) => {
        const rankedCards = [...cards].sort((a, b) => getPreviewCardRank(a) - getPreviewCardRank(b));
        const selectedCards = [];
        const selectedSet = new Set();
        const previewGroups = [
          ['drinks', 'drink', 'soda', 'cola', 'fanta', 'pepsi', 'coke', 'beverage'],
          ['candy', 'chocolate', 'gummies', 'gummy', 'skittles', 'starburst', 'snickers'],
          ['chips', 'chip', 'crisps', 'doritos', 'lays', 'pringles'],
          ['cookies', 'cookie', 'biscuit', 'biscuits', 'oreo'],
        ];

        const addCard = (card) => {
          if (!card || selectedSet.has(card)) return;
          selectedSet.add(card);
          selectedCards.push(card);
        };

        previewGroups.forEach((groupTokens) => {
          addCard(rankedCards.find((card) => !selectedSet.has(card) && cardHasAnyText(card, groupTokens)));
        });

        rankedCards.forEach((card) => {
          if (selectedCards.length < previewProductLimit) {
            addCard(card);
          }
        });

        return [...selectedCards, ...cards.filter((card) => !selectedSet.has(card))];
      };

      const updateUrl = () => {
        const url = new URL(window.location.href);
        Object.values(groupMap).forEach((config) => {
          url.searchParams.delete(config.param);
        });
        url.searchParams.delete('find_sort');

        Object.entries(committedState).forEach(([group, values]) => {
          if (values.length > 0) {
            url.searchParams.set(groupMap[group].param, values.join(','));
          }
        });

        if (sortControl && sortControl.value !== 'recommended') {
          url.searchParams.set('find_sort', sortControl.value);
        }

        window.history.replaceState({}, '', url);
      };

      const getResultsColumnCount = () => {
        if (!resultsGrid) return 1;
        const columns = window.getComputedStyle(resultsGrid).gridTemplateColumns.trim().split(/\s+/).filter(Boolean);
        return Math.max(columns.length, 1);
      };

      const getBalancedWindowLimit = (totalCount, baseLimit, layoutExtraCells) => {
        if (totalCount <= baseLimit) return totalCount;
        const columns = getResultsColumnCount();
        let limit = Math.min(baseLimit, totalCount);
        const remainder = (limit + layoutExtraCells) % columns;

        if (remainder > 0) {
          limit = Math.min(totalCount, limit + columns - remainder);
        }

        return limit;
      };

      const shouldFeatureResult = (index, visibleCount, filteredMode) => {
        if (index === 0) return true;
        if (!filteredMode) return false;
        if (!productWindowExpanded || index % 12 !== 0) return false;
        return visibleCount - index > 8;
      };

      const renderResults = (showResults, shouldUpdateUrl) => {
        const filteredMode = hasFilters(committedState);
        const matches = getMatches(committedState);
        const shouldShowResults = matches.length > 0 || filteredMode || showResults;
        const sortedMatches = sortCards(matches);
        const orderedMatches = filteredMode ? sortedMatches : getPreviewShowcaseCards(sortedMatches);
        const estimatedLayoutExtraCells = 3;
        const windowLimit = productWindowExpanded
          ? orderedMatches.length
          : getBalancedWindowLimit(orderedMatches.length, filteredMode ? filteredProductLimit : previewProductLimit, estimatedLayoutExtraCells);
        const visibleMatches = productWindowExpanded ? orderedMatches : orderedMatches.slice(0, windowLimit);
        const visibleSet = new Set(visibleMatches);

        if (resultsGrid) {
          sortCards(originalCards).forEach((card) => {
            resultsGrid.append(card);
          });
          orderedMatches.forEach((card) => {
            resultsGrid.append(card);
          });
        }

        resultCards.forEach((card) => {
          card.classList.remove(...resultLayoutClasses);
          card.style.removeProperty('--gs-result-span');
          card.removeAttribute('data-gs-visible-index');
          card.hidden = !visibleSet.has(card);
        });

        visibleMatches.forEach((card, index) => {
          card.dataset.gsVisibleIndex = String(index + 1);
          if (shouldFeatureResult(index, visibleMatches.length, filteredMode)) {
            const featureIndex = Math.floor(index / 12);
            const featureSide = ['left', 'right'][featureIndex % 2];
            card.classList.add('is-featured-result', `is-featured-result--${featureSide}`);
          }
        });

        updateCount(matches.length);
        updateResultsWindowCopy(matches.length, visibleMatches.length, filteredMode);
        renderChips();

        if (results) {
          results.hidden = !shouldShowResults;
        }

        if (emptyState) {
          emptyState.hidden = !shouldShowResults || matches.length !== 0;
        }

        clearButtons.forEach((button) => {
          button.hidden = !filteredMode;
        });

        shell.classList.toggle('is-filtered', shouldShowResults);
        shell.classList.toggle('has-active-filters', filteredMode);
        refreshOptionAvailability(committedState);

        if (shouldUpdateUrl) {
          updateUrl();
        }

        if (!filteredMode && !showResults) syncInputsFromState();
      };

      const syncServerRenderedResults = () => {
        const matches = getMatches(committedState);
        const visibleMatches = resultCards.filter((card) => !card.hidden);

        updateCount(matches.length);
        updateResultsWindowCopy(matches.length, visibleMatches.length, false);
        renderChips();

        if (results) {
          results.hidden = false;
        }

        if (emptyState) {
          emptyState.hidden = true;
        }

        clearButtons.forEach((button) => {
          button.hidden = true;
        });

        shell.classList.add('is-filtered');
        shell.classList.remove('has-active-filters');
        refreshOptionAvailability(committedState);
      };

      const closeDialog = () => {
        if (!dialog) return;
        document.documentElement.classList.remove('gs-find-snacks-dialog-open');
        document.body.classList.remove('gs-find-snacks-dialog-open');
        if (dialog.open) {
          dialog.close();
        }
        if (activeTrigger) {
          activeTrigger.focus();
        }
      };

      const openDialog = (event) => {
        if (event) {
          event.preventDefault();
          activeTrigger = event.currentTarget;
        }
        if (!dialog) return;
        syncInputsFromState();
        updateDialogSummary();
        document.documentElement.classList.add('gs-find-snacks-dialog-open');
        document.body.classList.add('gs-find-snacks-dialog-open');
        if (typeof dialog.showModal === 'function') {
          dialog.showModal();
        } else {
          dialog.setAttribute('open', '');
        }
      };

      const clearAll = (hideResults) => {
        Object.keys(committedState).forEach((group) => {
          committedState[group] = [];
        });
        if (sortControl) {
          sortControl.value = 'recommended';
        }
        productWindowExpanded = false;
        syncInputsFromState();
        renderResults(true, true);
        if (hideResults && results) {
          updateUrl();
        }
        updateDialogSummary();
      };

      const loadFromUrl = () => {
        const params = new URLSearchParams(window.location.search);
        let foundFilters = false;

        params.forEach((value, param) => {
          const group = paramToGroup[param];
          if (!group) return;
          committedState[group] = value.split(',').map((item) => item.trim()).filter(Boolean);
          if (committedState[group].length > 0) {
            foundFilters = true;
          }
        });

        if (sortControl && params.get('find_sort')) {
          sortControl.value = params.get('find_sort');
        }

        syncInputsFromState();
        if (!foundFilters && (!sortControl || sortControl.value === 'recommended')) {
          syncServerRenderedResults();
          return;
        }

        renderResults(foundFilters, false);
      };

      openButtons.forEach((button) => {
        button.addEventListener('click', openDialog);
      });

      checkboxes.forEach((input) => {
        input.addEventListener('change', updateDialogSummary);
      });

      if (closeButton) {
        closeButton.addEventListener('click', closeDialog);
      }

      if (dialog) {
        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) {
            closeDialog();
          }
        });
        dialog.addEventListener('close', () => {
          document.documentElement.classList.remove('gs-find-snacks-dialog-open');
          document.body.classList.remove('gs-find-snacks-dialog-open');
        });
      }

      if (resetButton) {
        resetButton.addEventListener('click', () => {
          clearAll(false);
        });
      }

      if (applyButton) {
        applyButton.addEventListener('click', () => {
          committedState = getStateFromInputs(checkboxes);
          productWindowExpanded = false;
          renderResults(true, true);
          closeDialog();
          if (results && !results.hidden) {
            results.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      }

      clearButtons.forEach((button) => {
        button.addEventListener('click', () => {
          clearAll(true);
        });
      });

      if (sortControl) {
        sortControl.addEventListener('change', () => {
          productWindowExpanded = false;
          renderResults(!results.hidden, true);
        });
      }

      if (resultsViewAll) {
        resultsViewAll.addEventListener('click', () => {
          productWindowExpanded = true;
          renderResults(true, true);
        });
      }

      loadFromUrl();
    };

    const initAllShells = () => {
      document.querySelectorAll('[data-gs-find-snacks-shell]').forEach(initShell);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllShells, { once: true });
    } else {
      initAllShells();
    }

    document.addEventListener('shopify:section:load', initAllShells);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gs-home-social-proof"] && !Shopify.designMode) return;
  try {
    
  const socialTriggers = document.querySelectorAll('[data-gs-social-open]');

  socialTriggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const section = trigger.closest('.gs-home-social');
      const modal = section && section.querySelector('[data-gs-social-modal]');
      const frame = modal && modal.querySelector('[data-gs-social-frame]');
      const title = modal && modal.querySelector('h3');
      const originalLink = modal && modal.querySelector('[data-gs-social-link]');
      const closeButton = modal && modal.querySelector('[data-gs-social-close]:not(.gs-home-social-modal__backdrop)');
      const embedUrl = trigger.dataset.gsEmbedUrl;
      const originalUrl = trigger.dataset.gsOriginalUrl;
      const modalTitle = trigger.dataset.gsModalTitle || 'Snack reaction';

      if (!modal || !frame || !embedUrl) {
        if (originalUrl) {
          window.open(originalUrl, '_blank', 'noopener');
        }

        return;
      }

      frame.replaceChildren();

      const iframe = document.createElement('iframe');
      iframe.src = embedUrl;
      iframe.title = modalTitle;
      iframe.loading = 'lazy';
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      iframe.allowFullscreen = true;
      frame.appendChild(iframe);

      if (title) {
        title.textContent = modalTitle;
      }

      if (originalLink) {
        if (originalUrl) {
          originalLink.href = originalUrl;
          originalLink.hidden = false;
        } else {
          originalLink.hidden = true;
        }
      }

      modal.hidden = false;
      closeButton && closeButton.focus();
    });
  });

  document.addEventListener('click', (event) => {
    const close = event.target.closest('[data-gs-social-close]');
    if (!close) return;

    const modal = close.closest('[data-gs-social-modal]');
    const frame = modal && modal.querySelector('[data-gs-social-frame]');

    if (frame) {
      frame.replaceChildren();
    }

    if (modal) {
      modal.hidden = true;
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    document.querySelectorAll('[data-gs-social-modal]:not([hidden])').forEach((modal) => {
      const frame = modal.querySelector('[data-gs-social-frame]');
      if (frame) {
        frame.replaceChildren();
      }

      modal.hidden = true;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gs-mystery-sack-landing"] && !Shopify.designMode) return;
  try {
    
  const resetMysteryLandingInitialScroll = () => {
    const landing = document.querySelector('[data-gs-module="mystery_snack_sack_editorial"]');
    const reviewHashPattern = /^#mystery-sack-(featured-reviews|reviews)-/;
    const hasHash = window.location.hash.length > 0;

    if (!landing || (hasHash && !reviewHashPattern.test(window.location.hash))) return;

    const resetScroll = () => {
      const documentScroller = document.scrollingElement || document.documentElement;
      const desktopScroller = window.matchMedia('(min-width: 990px)').matches
        ? document.querySelector('.page-wrapper')
        : null;

      [documentScroller, desktopScroller].forEach((scroller) => {
        if (!scroller || typeof scroller.scrollTo !== 'function') return;
        scroller.scrollTo({ top: 0, left: 0, behavior: 'instant' });
      });

      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });

      try {
        const currentState = typeof history.state === 'object' && history.state !== null ? history.state : {};

        if (reviewHashPattern.test(window.location.hash)) {
          history.replaceState(
            { ...currentState, scrollTop: 0 },
            '',
            `${window.location.pathname}${window.location.search}`
          );
        } else {
          history.replaceState({ ...currentState, scrollTop: 0 }, '');
        }
      } catch (_) {
        // Ignore browser history edge cases; the visible scroll reset still works.
      }
    };

    resetScroll();
    window.requestAnimationFrame(() => {
      resetScroll();
      window.requestAnimationFrame(resetScroll);
    });
  };

  resetMysteryLandingInitialScroll();
  window.addEventListener('pageshow', resetMysteryLandingInitialScroll);
  window.addEventListener('load', resetMysteryLandingInitialScroll, { once: true });

  document.querySelectorAll('[data-gs-mystery-reveal]').forEach((reveal) => {
    const range = reveal.querySelector('.gs-mystery-landing__reveal-range');
    const cueRoot = reveal.closest('.gs-mystery-landing__reveal-band');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let cueTimer;

    if (!range) return;

    const clearCue = () => {
      window.clearTimeout(cueTimer);
      reveal.classList.remove('is-cueing');
      cueRoot?.classList.remove('is-cueing');
    };

    const restartCue = () => {
      if (reduceMotion || reveal.classList.contains('is-touched')) return;

      clearCue();
      void reveal.offsetWidth;
      reveal.classList.add('is-cueing');
      cueRoot?.classList.add('is-cueing');
      cueTimer = window.setTimeout(clearCue, 7800);
    };

    const markTouched = () => {
      reveal.classList.add('is-touched');
      clearCue();
    };

    const setReveal = (value) => {
      const revealValue = Number(value) || 0;
      reveal.style.setProperty('--reveal', `${revealValue}%`);
      reveal.classList.toggle('has-example-badge', revealValue >= 35);
    };

    range.addEventListener('pointerdown', markTouched);
    range.addEventListener('touchstart', markTouched, { passive: true });
    range.addEventListener('keydown', markTouched);
    range.addEventListener('input', () => {
      markTouched();
      setReveal(range.value);
    });

    setReveal(range.value || 0);

    if (!reduceMotion && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) restartCue();
        });
      }, { threshold: 0.35 });

      observer.observe(cueRoot || reveal);
    } else {
      restartCue();
    }
  });

  document.querySelectorAll('[data-gs-mystery-review-toggle]').forEach((toggle) => {
    const feedId = toggle.getAttribute('aria-controls');
    const feed = document.getElementById(feedId);
    const label = toggle.querySelector('[data-gs-review-toggle-label]');
    const icon = toggle.querySelector('[data-gs-review-toggle-icon]');
    const fallback = toggle.parentElement?.querySelector('[data-gs-review-fallback]');

    if (!feed) return;

    const closedLabel = toggle.dataset.labelClosed || 'VIEW MORE VERIFIED REVIEWS';
    const openLabel = toggle.dataset.labelOpen || 'HIDE VERIFIED REVIEWS';

    if (fallback) {
      fallback.hidden = true;
    }

    const refreshJudgeMe = () => {
      if (window.jdgm && typeof window.jdgm.renderWidgets === 'function') {
        window.jdgm.renderWidgets();
      } else if (window.jdgm && typeof window.jdgm.renderWidget === 'function') {
        window.jdgm.renderWidget();
      }
    };

    const setOpen = (isOpen) => {
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      feed.hidden = !isOpen;

      if (label) {
        label.textContent = isOpen ? openLabel : closedLabel;
      }

      if (icon) {
        icon.textContent = '+';
      }

      if (isOpen) {
        window.requestAnimationFrame(refreshJudgeMe);
      } else {
        window.requestAnimationFrame(() => {
          const rect = toggle.getBoundingClientRect();

          if (rect.top < 0 || rect.bottom > window.innerHeight) {
            toggle.scrollIntoView({ block: 'center' });
          }
        });
      }
    };

    setOpen(false);

    toggle.addEventListener('click', () => {
      const isOpen = toggle.getAttribute('aria-expanded') !== 'true';
      setOpen(isOpen);
      toggle.focus({ preventScroll: true });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gs-pdp-recently-viewed"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const storageKey = 'gs_recently_viewed_products_v1';
    const availabilityStorageKey = 'gs_recently_viewed_public_products_v1';
    const maxStoredProducts = 24;
    const validationBatchSize = 4;
    const availabilityCacheTtl = 5 * 60 * 1000;
    const availabilityCache = new Map();

    const readHistory = () => {
      try {
        const value = window.localStorage.getItem(storageKey);
        const parsed = value ? JSON.parse(value) : [];
        return Array.isArray(parsed) ? parsed : [];
      } catch (error) {
        return [];
      }
    };

    const writeHistory = (items) => {
      try {
        window.localStorage.setItem(storageKey, JSON.stringify(items.slice(0, maxStoredProducts)));
      } catch (error) {
        // Ignore private browsing or storage quota errors.
      }
    };

    const readAvailabilityCache = () => {
      try {
        const value = window.sessionStorage.getItem(availabilityStorageKey);
        const parsed = value ? JSON.parse(value) : {};
        if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return;

        Object.entries(parsed).forEach(([handle, entry]) => {
          if (!entry || typeof entry !== 'object') return;
          if (entry.status !== 'public' && entry.status !== 'unavailable') return;
          if (!Number.isFinite(entry.checkedAt) || Date.now() - entry.checkedAt > availabilityCacheTtl) return;
          availabilityCache.set(handle, entry);
        });
      } catch (error) {
        // Ignore private browsing or unavailable session storage.
      }
    };

    const writeAvailabilityCache = () => {
      try {
        window.sessionStorage.setItem(availabilityStorageKey, JSON.stringify(Object.fromEntries(availabilityCache)));
      } catch (error) {
        // Ignore private browsing or storage quota errors.
      }
    };

    const normalizedHandle = (handle) => {
      if (typeof handle !== 'string') return '';
      const normalized = handle.trim().toLowerCase();
      return /^[a-z0-9][a-z0-9-]*$/.test(normalized) ? normalized : '';
    };

    const publicProductStatus = async (rawHandle) => {
      const handle = normalizedHandle(rawHandle);
      if (!handle) return 'unavailable';
      const cachedEntry = availabilityCache.get(handle);
      if (cachedEntry && Date.now() - cachedEntry.checkedAt <= availabilityCacheTtl) return cachedEntry.status;

      const routesRoot = window.Shopify?.routes?.root || '/';
      const productUrl = `${routesRoot}products/${encodeURIComponent(handle)}.js`;

      try {
        const response = await window.fetch(productUrl, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        });

        if (response.ok) {
          availabilityCache.set(handle, { status: 'public', checkedAt: Date.now() });
          writeAvailabilityCache();
          return 'public';
        }

        if (response.status === 404) {
          availabilityCache.set(handle, { status: 'unavailable', checkedAt: Date.now() });
          writeAvailabilityCache();
          return 'unavailable';
        }
      } catch (error) {
        // A transient network error should not erase browser history.
      }

      return 'unknown';
    };

    const validateHistory = async (items, visibleLimit) => {
      const publicItems = [];
      const invalidHandles = new Set();

      for (let index = 0; index < items.length && publicItems.length < visibleLimit; index += validationBatchSize) {
        const batch = items.slice(index, index + validationBatchSize);
        const statuses = await Promise.all(batch.map((item) => publicProductStatus(item.handle)));

        batch.forEach((item, batchIndex) => {
          const status = statuses[batchIndex];
          if (status === 'public' && publicItems.length < visibleLimit) publicItems.push(item);
          if (status === 'unavailable') invalidHandles.add(item.handle);
        });
      }

      return {
        publicItems,
        cleanedHistory: items.filter((item) => !invalidHandles.has(item.handle)),
      };
    };

    const safeProductUrl = (url) => {
      if (typeof url !== 'string') return '#';
      return url.startsWith('/products/') ? url : '#';
    };

    const safeImageUrl = (url) => {
      if (typeof url !== 'string') return '';
      if (url.startsWith('https://') || url.startsWith('http://') || url.startsWith('//') || url.startsWith('/')) {
        return url;
      }
      return '';
    };

    const getCurrentProduct = (section) => ({
      handle: section.dataset.currentHandle || '',
      title: section.dataset.currentTitle || '',
      text: section.dataset.currentText || '',
      url: safeProductUrl(section.dataset.currentUrl || ''),
      image: safeImageUrl(section.dataset.currentImage || ''),
      price: section.dataset.currentPrice || '',
      vendor: section.dataset.currentVendor || '',
      productType: section.dataset.currentProductType || '',
      originFlag: section.dataset.currentOriginFlag || '',
      originLabel: section.dataset.currentOriginLabel || '',
    });

    const appendText = (parent, text) => {
      parent.textContent = text || '';
      return parent;
    };

    const buildCard = (item, index, section, showPrices) => {
      const cardCtaLabel = section.dataset.cardCtaLabel || 'View again';
      const url = safeProductUrl(item.url);
      const imageUrl = safeImageUrl(item.image);

      const card = document.createElement('article');
      card.className = 'gs-home-product-card gs-home-product-card--collection gs-pdp-recently-viewed__card';
      card.dataset.gsEvent = 'gs_product_card_view';
      card.dataset.gsSurface = 'pdp';
      card.dataset.gsModule = section.dataset.gsModule || 'pdp_recently_viewed';
      card.dataset.gsModuleId = section.dataset.gsModuleId || 'pdp-recently-viewed';
      card.dataset.gsPosition = String(index + 1);
      card.dataset.gsProductHandle = item.handle || '';
      card.dataset.gsBrandFamily = item.vendor || '';

      const productLink = document.createElement('a');
      productLink.className = 'gs-home-product-card__link gs-pdp-recently-viewed__product-link';
      productLink.href = url;
      productLink.setAttribute('aria-label', item.title || 'Recently viewed product');
      productLink.dataset.gsEvent = 'gs_product_card_click';
      productLink.dataset.gsSurface = 'pdp';
      productLink.dataset.gsModule = card.dataset.gsModule;
      productLink.dataset.gsModuleId = card.dataset.gsModuleId;
      productLink.dataset.gsPosition = card.dataset.gsPosition;
      productLink.dataset.gsClickTarget = 'recently_viewed_card';
      productLink.dataset.gsProductHandle = item.handle || '';

      const media = document.createElement('figure');
      media.className = 'gs-home-product-card__media gs-pdp-recently-viewed__media';

      if (imageUrl) {
        const image = document.createElement('img');
        image.className = 'gs-home-product-card__image gs-pdp-recently-viewed__image';
        image.loading = 'lazy';
        image.decoding = 'async';
        image.alt = item.title || '';
        image.src = imageUrl;
        media.appendChild(image);
      } else {
        const placeholder = document.createElement('span');
        placeholder.className = 'gs-home-product-card__placeholder gs-pdp-recently-viewed__placeholder';
        placeholder.setAttribute('aria-hidden', 'true');
        media.appendChild(placeholder);
      }

      const productTypeKey = (item.productType || '').toLowerCase();
      const productIdentity = `${item.title || ''} ${item.handle || ''}`.toLowerCase();
      const suppressOriginFlag =
        productTypeKey.includes('merch') ||
        productTypeKey.includes('bundle') ||
        productTypeKey.includes('gift card') ||
        productIdentity.includes('mystery snack sack') ||
        productIdentity.includes('galactic grab bag') ||
        productIdentity.includes('420 deal') ||
        productIdentity.includes('4 for 20') ||
        productIdentity.includes('4-for-20');

      if (item.originFlag && !suppressOriginFlag) {
        const flag = document.createElement('figcaption');
        flag.className = 'gs-home-product-card__badge gs-home-product-card__badge--flag';
        flag.setAttribute('role', 'img');
        flag.setAttribute('aria-label', item.originLabel || 'Product origin');
        const flagIcon = document.createElement('span');
        flagIcon.setAttribute('aria-hidden', 'true');
        appendText(flagIcon, item.originFlag);
        flag.appendChild(flagIcon);
        media.appendChild(flag);
      }

      const body = document.createElement('div');
      body.className = 'gs-home-product-card__body gs-pdp-recently-viewed__body';

      const title = document.createElement('h3');
      appendText(title, item.title || 'Recently viewed product');
      body.appendChild(title);

      if (item.text) {
        const text = document.createElement('p');
        appendText(text, item.text);
        body.appendChild(text);
      }

      if (showPrices && item.price) {
        const price = document.createElement('span');
        price.className = 'gs-home-product-card__price gs-pdp-recently-viewed__price';
        appendText(price, item.price);
        body.appendChild(price);
      }

      const button = document.createElement('a');
      button.className = 'gs-home-product-card__quick-add-button gs-pdp-recently-viewed__button';
      button.href = url;
      button.dataset.gsEvent = 'gs_module_click';
      button.dataset.gsSurface = 'pdp';
      button.dataset.gsModule = card.dataset.gsModule;
      button.dataset.gsModuleId = card.dataset.gsModuleId;
      button.dataset.gsPosition = card.dataset.gsPosition;
      button.dataset.gsClickTarget = 'recently_viewed_cta';
      button.dataset.gsProductHandle = item.handle || '';
      appendText(button, cardCtaLabel);

      productLink.appendChild(media);
      productLink.appendChild(body);
      card.appendChild(productLink);
      card.appendChild(button);
      return card;
    };

    const initRecentlyViewed = (root = document) => {
      const sections = Array.from(root.querySelectorAll('[data-gs-recently-viewed]'));
      if (root instanceof Element && root.matches('[data-gs-recently-viewed]')) sections.unshift(root);

      sections.forEach(async (section) => {
        if (section.dataset.gsInitialized === 'true' || section.dataset.gsInitialized === 'pending') return;
        section.dataset.gsInitialized = 'pending';

        const currentProduct = getCurrentProduct(section);
        const history = readHistory().filter((item) => item && item.handle && item.handle !== currentProduct.handle);
        const seenHandles = new Set();
        const dedupedHistory = history.filter((item) => {
          if (seenHandles.has(item.handle)) return false;
          seenHandles.add(item.handle);
          return true;
        });

        const maxProducts = Number.parseInt(section.dataset.maxProducts || '4', 10);
        const visibleLimit = Number.isFinite(maxProducts) ? maxProducts : 4;
        const grid = section.querySelector('[data-gs-recently-viewed-grid]');

        if (currentProduct.handle && currentProduct.title && currentProduct.url !== '#') {
          writeHistory([currentProduct].concat(dedupedHistory));
        }

        const { publicItems, cleanedHistory } = await validateHistory(dedupedHistory, visibleLimit);

        if (grid && publicItems.length) {
          const showPrices = grid.dataset.showPrices === 'true';
          grid.replaceChildren(...publicItems.map((item, index) => buildCard(item, index, section, showPrices)));
          section.hidden = false;
          section.dispatchEvent(new CustomEvent('gs:merchandising:ready', { bubbles: true }));
        }

        if (currentProduct.handle && currentProduct.title && currentProduct.url !== '#') {
          writeHistory([currentProduct].concat(cleanedHistory));
        } else {
          writeHistory(cleanedHistory);
        }

        section.dataset.gsInitialized = 'true';
      });
    };

    readAvailabilityCache();
    initRecentlyViewed();
    document.addEventListener('DOMContentLoaded', () => initRecentlyViewed());
    document.addEventListener('shopify:section:load', (event) => initRecentlyViewed(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gs-pdp-recommendation-slot"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const shuffleGrid = (grid) => {
      if (grid.dataset.gsRandomized === 'true') return;
      if (grid.dataset.gsRandomizeProducts !== 'true') return;

      const visibleLimit = Number.parseInt(grid.dataset.gsVisibleProductLimit || '4', 10);
      const limitOnePerVendor = grid.dataset.gsLimitOnePerVendor === 'true';
      const cards = Array.from(grid.querySelectorAll('[data-gs-random-pool-card]'));

      if (!cards.length || !Number.isFinite(visibleLimit)) return;

      for (let index = cards.length - 1; index > 0; index -= 1) {
        const targetIndex = Math.floor(Math.random() * (index + 1));
        const currentCard = cards[index];
        cards[index] = cards[targetIndex];
        cards[targetIndex] = currentCard;
      }

      const prioritizedCards = [];
      const repeatedVendorCards = [];
      const seenVendorKeys = new Set();

      cards.forEach((card) => {
        const dedupeKey = (card.dataset.gsDedupeKey || card.dataset.gsBrandFamily || '').trim().toLowerCase();

        if (!limitOnePerVendor || !dedupeKey) {
          prioritizedCards.push(card);
          return;
        }

        if (seenVendorKeys.has(dedupeKey)) {
          repeatedVendorCards.push(card);
          return;
        }

        seenVendorKeys.add(dedupeKey);
        prioritizedCards.push(card);
      });

      prioritizedCards.concat(repeatedVendorCards).forEach((card, index) => {
        const nextPosition = String(index + 1);

        card.hidden = index >= visibleLimit;
        card.dataset.gsPosition = nextPosition;
        card.querySelectorAll('[data-gs-position]').forEach((trackedElement) => {
          trackedElement.dataset.gsPosition = nextPosition;
        });
        grid.appendChild(card);
      });

      grid.dataset.gsRandomized = 'true';
      grid.dispatchEvent(new CustomEvent('gs:recommendation-rows-ready', { bubbles: true }));
    };

    const shuffleRecommendationRows = (root = document) => {
      root
        .querySelectorAll('.gs-pdp-reco-slot__grid[data-gs-randomize-products="true"]')
        .forEach(shuffleGrid);
    };

    shuffleRecommendationRows();
    document.addEventListener('DOMContentLoaded', () => shuffleRecommendationRows());
    document.addEventListener('shopify:section:load', (event) => shuffleRecommendationRows(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
